export const builderLeftPanelWidth = 360;
export const behaviorsModalPreviewContainerLeftOffset =
    builderLeftPanelWidth + 36;

export const VIEWER_HEADER_TOP_OFFSET = 10;
export const BUILDER_HEADER_TOP_OFFSET = 10;
export const BUILDER_CONTROLS_TOP_OFFSET = 26;

export const HEADER_BUTTON_HEIGHT = 42;

export const ELEMENTS_PANEL_BUTTON_HEIGHT = 54;
export const ELEMENTS_PANEL_BUTTON_BOTTOM_OFFSET = 20;
export const INITIAL_ELEMENTS_PANEL_LEFT_OFFSET = 4;

export const SCENE_PAGE_OUTER_OFFSET = 16;

export const VIEWER_CAMERA_CONTROLS_BOTTOM_OFFSET = ELEMENTS_PANEL_BUTTON_BOTTOM_OFFSET;
export const BUILDER_CAMERA_CONTROLS_BOTTOM_OFFSET = ELEMENTS_PANEL_BUTTON_BOTTOM_OFFSET;

export const CUSTOM_HIGHCHARTS_COLOR_IDX_1 = '#d781fc'; // overriding default Highcharts color at index 1 since it is not visible in our dark themes

export const APP_BACKGROUND_KRAKEN = '#16203b';
